module.exports = __webpack_public_path__ + "e3996ddfb1a2617d663bf89ab7132441.jpg";